/**
 * Marker attached to UI connector tiles that originated from the WalletConnect
 * wallet registry (i.e. not a locally-installed adapter/connector). Both chains
 * use this to decide whether to route a connect through the QR / deep-link path.
 */
export const WC_REGISTRY_MARKER = Symbol('wcRegistry');
export const getRegistryEntry = (c) => {
    if (!c || typeof c !== 'object')
        return undefined;
    return c[WC_REGISTRY_MARKER];
};
